var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "live-shopping-details" },
    [
      _c("div", { staticClass: "h3 live-shopping-item-name" }, [
        _c(
          "a",
          { attrs: { href: _vm._f("itemURL")(_vm.liveShoppingData.item) } },
          [
            _c("div", { staticClass: "two-lines-of-text" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    (
                      _vm.liveShoppingData.item.texts.name1.match(
                        /[^\ - ]+ -/
                      ) || [""]
                    ).pop()
                  ) +
                  " \n                " +
                  _vm._s(_vm.liveShoppingData.item.texts.name2) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "live-shopping-item-name-condition two-lines-of-text"
              },
              [_vm._v(_vm._s(_vm.liveShoppingData.item.texts.name3))]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.hasStarted
        ? _c("div", { staticClass: "live-shopping-prices" }, [
            _c("div", { staticClass: "live-shopping-prices-inner" }, [
              _c("div", { staticClass: "live-shopping-prices-container" }, [
                _vm.displaySettings.showCrossPrice &&
                _vm.prices.rrp &&
                _vm.prices.rrp.unitPrice.value > 0
                  ? _c("span", [
                      _vm.liveShoppingData.item.prices.default.unitPrice.value >
                      _vm.liveShoppingData.item.prices.rrp.unitPrice.value
                        ? _c("span", [
                            _vm._v("\n                        statt "),
                            _c("del", [
                              _vm._v(
                                _vm._s(
                                  _vm.liveShoppingData.item.prices.default
                                    .unitPrice.formatted
                                )
                              )
                            ])
                          ])
                        : _c("span", [
                            _vm._v("\n                        statt "),
                            _c("del", [
                              _vm._v(
                                _vm._s(
                                  _vm.liveShoppingData.item.prices.rrp.unitPrice
                                    .formatted
                                )
                              )
                            ])
                          ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.displaySettings.showCrossPrice &&
                _vm.prices.rrp &&
                _vm.prices.rrp.unitPrice.value === 0
                  ? _c("span", [_c("span", [_vm._v(" ")])])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "live-shopping-price" }, [
                  _c("strong", [
                    _c("span", { staticClass: "d-none d-lg-inline" }, [
                      _vm._v("heute ")
                    ]),
                    _vm._v(
                      "nur " + _vm._s(_vm.prices.price.unitPrice.formatted)
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "live-shopping-prices-additional-info" },
              [
                !(
                  _vm.liveShoppingData.item.unit.unitOfMeasurement === "C62" &&
                  _vm.liveShoppingData.item.unit.content === 1
                )
                  ? _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.liveShoppingData.item.unit.content))
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.liveShoppingData.item.unit.names.name)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.liveShoppingData.item.variation.mayShowUnitPrice
                        ? _c("span", [
                            _vm._v("| " + _vm._s(_vm.prices.price.basePrice))
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showNetPrices
                  ? [
                      _vm._v(
                        _vm._s(_vm.$translate("Ceres::Template.itemExclVAT"))
                      )
                    ]
                  : [
                      _vm._v(
                        _vm._s(_vm.$translate("Ceres::Template.itemInclVAT"))
                      )
                    ],
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Ceres::Template.itemExclusive")) +
                    "\n            "
                ),
                _vm.$ceres.config.global.shippingCostsCategoryId > 0
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.konsolenkost.de/versand",
                          title: _vm.$translate(
                            "Ceres::Template.itemShippingCosts"
                          )
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.itemShippingCosts")
                          )
                        )
                      ]
                    )
                  : _c(
                      "a",
                      {
                        attrs: {
                          title: _vm.$translate(
                            "Ceres::Template.itemShippingCosts"
                          )
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.itemShippingCosts")
                          )
                        )
                      ]
                    )
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasClosed
        ? _c("div", [
            _c(
              "a",
              {
                staticClass:
                  "btn btn-primary d-block d-lg-inline-block my-lg-3",
                attrs: { href: _vm._f("itemURL")(_vm.liveShoppingData.item) }
              },
              [
                _vm._v("\n            Will ich haben "),
                _c("span", { staticClass: "d-none d-lg-inline" }, [_vm._v(">")])
              ]
            )
          ])
        : _c("div", [_vm._m(0)]),
      _vm._v(" "),
      _vm._t("after-item-name"),
      _vm._v(" "),
      _vm.displaySettings.showTimer || _vm.displaySettings.showStock
        ? _c(
            "div",
            { staticClass: "live-shopping-countdown" },
            [
              _vm.hasStarted && !_vm.hasClosed
                ? [
                    _vm.displaySettings.showStock
                      ? _c("div", { staticClass: "live-shopping-progress" }, [
                          _vm.displaySettings.showStockProgress
                            ? _c("div", { staticClass: "progress" }, [
                                _vm.liveShoppingData.liveShopping.quantitySold <
                                _vm.liveShoppingData.liveShopping.quantityMax
                                  ? _c("div", {
                                      staticClass: "progress-bar",
                                      class:
                                        "progress-" +
                                        Math.round(
                                          _vm.quantitySoldPercentage / 10
                                        ) *
                                          10,
                                      style:
                                        "width:" +
                                        _vm.quantitySoldPercentage +
                                        "%",
                                      attrs: {
                                        role: "progressbar",
                                        "aria-valuenow": "25",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    })
                                  : _c("div", {
                                      staticClass: "progress-bar-done",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        role: "progressbar",
                                        "aria-valuenow": "25",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "live-shopping-progress-heading" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.liveShoppingRemainingStock",
                                      {
                                        quantitySoldPercentage:
                                          _vm.quantitySoldPercentage
                                      }
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.hasClosed
                ? [
                    _vm.displaySettings.showStock
                      ? _c("div", { staticClass: "live-shopping-progress" }, [
                          _vm.displaySettings.showStockProgress
                            ? _c("div", { staticClass: "progress" }, [
                                _vm.liveShoppingData.liveShopping.quantitySold <
                                _vm.liveShoppingData.liveShopping.quantityMax
                                  ? _c("div", {
                                      staticClass: "progress-10",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        role: "progressbar",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    })
                                  : _c("div", {
                                      staticClass: "progress-bar-done",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        role: "progressbar",
                                        "aria-valuenow": "25",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(1)
                        ])
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        : _c("div", { staticClass: "thumb-content" }, [
            _c("div", [
              _c("div", { staticClass: "prices" }, [
                _c("div", { staticClass: "price-view-port" }, [
                  _vm.isCrossPriceVisible
                    ? _c("del", { staticClass: "crossprice" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("itemCrossPrice")(
                                _vm.prices.rrp.price.formatted
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.prices.price.price.formatted) +
                      " *\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.isCrossPriceVisible &&
              _vm.liveShoppingData.item.prices.default.lowestPrice.value
                ? _c("div", { staticClass: "category-lowest-price small" }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$translate(
                            "Ceres::Template.singleItemLowestPrice",
                            {
                              price:
                                _vm.liveShoppingData.item.prices.default
                                  .lowestPrice.formatted
                            }
                          )
                        )
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              !(
                _vm.liveShoppingData.item.unit.unitOfMeasurement === "C62" &&
                _vm.liveShoppingData.item.unit.content === 1
              )
                ? _c("div", { staticClass: "category-unit-price small" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.liveShoppingData.item.unit.content))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.liveShoppingData.item.unit.names.name))
                    ]),
                    _vm._v(" "),
                    _vm.liveShoppingData.item.variation.mayShowUnitPrice
                      ? _c("span", [
                          _vm._v("| " + _vm._s(_vm.prices.price.basePrice))
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "vat small text-muted" },
                [
                  _vm.showNetPrices
                    ? [
                        _vm._v(
                          _vm._s(_vm.$translate("Ceres::Template.itemExclVAT"))
                        )
                      ]
                    : [
                        _vm._v(
                          _vm._s(_vm.$translate("Ceres::Template.itemInclVAT"))
                        )
                      ],
                  _vm._v(
                    " " +
                      _vm._s(_vm.$translate("Ceres::Template.itemExclusive")) +
                      "\n                "
                  ),
                  _vm.$ceres.config.global.shippingCostsCategoryId > 0
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: "https://www.konsolenkost.de/versand",
                            title: _vm.$translate(
                              "Ceres::Template.itemShippingCosts"
                            )
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.itemShippingCosts"
                              )
                            )
                          )
                        ]
                      )
                    : _c(
                        "a",
                        {
                          attrs: {
                            title: _vm.$translate(
                              "Ceres::Template.itemShippingCosts"
                            )
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.itemShippingCosts"
                              )
                            )
                          )
                        ]
                      )
                ],
                2
              )
            ])
          ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass:
          "btn btn-primary btn-danger text-white d-block d-lg-inline-block my-lg-3"
      },
      [
        _vm._v("\n           AUSVERKAUFT* "),
        _c("span", { staticClass: "d-none d-lg-inline" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "live-shopping-progress-heading" }, [
      _c("span", [_vm._v("*Aktionsbestand ausverkauft")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }